import * as _ from "lodash-es";
import { useEffect, useState } from "react";

import { getBreakpointFromMediaMatch } from "@/util/ui_util";

export const useShowFullPricingMatrix = (debounceTime: number = 150) => {
    /**
     * State
     */
    const [showFullPricingMatrix, setShowFullPricingMatrix] = useState(true);

    /**
     * Effects
     */
    useEffect(() => {
        const _determineShouldShowFullPricingMatrix = () => {
            const bp = getBreakpointFromMediaMatch();
            setShowFullPricingMatrix(bp !== "extraSmall" && bp !== "small");
        };

        const _debouncedDetermineShouldShowFullPricingMatrix = _.debounce(
            _determineShouldShowFullPricingMatrix,
            debounceTime,
        );

        _determineShouldShowFullPricingMatrix();

        window.addEventListener(
            "resize",
            _debouncedDetermineShouldShowFullPricingMatrix,
        );

        return () => {
            window.removeEventListener(
                "resize",
                _debouncedDetermineShouldShowFullPricingMatrix,
            );
        };
    }, [debounceTime]);

    return showFullPricingMatrix;
};
